'use strict';

/**
 *
 * @name: nsSocialIconsHeader
 *
 */

import DirectiveTemplate from './nn-social-icons-header.directive.html';
import './nn-social-icons-header.directive.scss';

function NnSocialIconsHeaderDirective($localStorage, $rootScope) {

  'ngInject';

  return {
    restrict: 'E',
    scope: true,
    replace: true,
    template: DirectiveTemplate,
    link: function (scope) {

      /**
       *
       * @CONFIG
       *
       */

      var stateChangesCounter = 0;
      $rootScope.socialsHeaderVisible = true;
      scope.LABEL = $rootScope.lang !== 'zh-cn' ? 'CONNECT_WITH_NOWNESS' : 'FOLLOW_NOWNESS_ELSEWHERE_CHINESE';

      /**
       *
       * @PUBLIC
       *
       */

      scope.onCloseClick = () => {

        $rootScope.socialsHeaderVisible = false
        // $rootScope.dynamicStyles()
        $localStorage.socialHeaderClosedAt = new Date().getTime();
      };

      /**
       *
       * @PRIVATE
       *
       */


      function _lastSeenLonEnough() {

        if (!$localStorage.socialHeaderClosedAt) {

          return true;
        } else {

          return moment(JSON.parse($localStorage.socialHeaderClosedAt)).add(60, 'days') < new Date();
        }
      }

      /**
       *
       * @INIT
       *
       */

      if (_lastSeenLonEnough()) {

        scope.$on('$locationChangeSuccess', function () {

          stateChangesCounter += 1;

          if (stateChangesCounter >= 2 && _lastSeenLonEnough() && !$rootScope.isMobileDevice) {
            $rootScope.socialsHeaderVisible = true
            // $rootScope.dynamicStyles()
          }
        });
      } else {

        $rootScope.socialsHeaderVisible = false
        // $rootScope.dynamicStyles()
      }
    }
  };
}

export default NnSocialIconsHeaderDirective;



// WEBPACK FOOTER //
// ./app/components/nn-generic-directives/nn-social-icons-header/nn-social-icons-header.directive.js